import { createAction } from '@reduxjs/toolkit';

import { GetHasMorePendingRequest } from '../types';
import { RequestStatus } from '../../../../../../types';

export const getHasMorePending = createAction<GetHasMorePendingRequest>('comments/GET_HAS_MORE_PENDING');
export const setHasMorePending = createAction<boolean>('comments/SET_HAS_MORE_PENDING');

export const setHasMorePendingStatus = createAction<RequestStatus>('comments/SET_HAS_MORE_PENDING_STATUS');
